import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@klickdata/core/auth';
import { CustomerLanding } from '@klickdata/core/customer';
import { PaymentService } from '@klickdata/core/payment';
import { SubsPlan } from '@klickdata/core/payment/src/payment.service';
import { ResourceService } from '@klickdata/core/resource';
import { User } from '@klickdata/core/user';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { Observable, of, takeUntil } from 'rxjs';

@Component({
    selector: 'app-chat-io-payment',
    templateUrl: './chat-io-payment.component.html',
    styleUrls: ['./chat-io-payment.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatIoPaymentComponent extends OnDestroyHandler implements OnInit {
    public customerLanding$: Observable<CustomerLanding>;
    public subscriptionPlans$: Observable<SubsPlan[]>;
    public isLoading$: Observable<boolean>;
    public user$: Observable<User>;

    constructor(
        protected auth: AuthService,
        protected resourceService: ResourceService,
        protected paymentService: PaymentService,
        protected router: Router
    ) {
        super();
    }
    ngOnInit(): void {
        this.customerLanding$ = this.auth.getCustomerLanding();
        this.subscriptionPlans$ = this.paymentService.getSubscriptionPlans();
        this.user$ = this.auth.getUser();
    }
    onPaymentSucces(isSuccess: boolean) {
        if (isSuccess) {
            this.isLoading$ = of(true);
            this.auth
                .refreshToken()
                .pipe(takeUntil(this.destroy))
                .subscribe(() => {
                    this.isLoading$ = of(false);
                    this.router.navigateByUrl('home/dashboard');
                });
        }
    }
    logout() {
        this.auth.logout();
    }
}
